<template>
  <mdb-container v-if="currentGroup">
    <div>
      <banner-small :group="currentGroup" title="Broadcast Message"/>
      <div v-show="view=='list'">
        <data-table :clickHandler="editMessage"
                    :add-handler="newMessage"
                    :columns="columns"
                    add-label="New Message"
                    :show-add-button="true"
                    :dataSource="'/group/broadcastList/' + $route.params.id"
                    pageTitle="Broadcast Messages"/>
      </div>
      <div v-if="view=='edit'">
        <mdb-card class="mb-4">
          <mdb-card-header>
            <h3>Broadcast Message</h3>
            <small>
              For event announcements and reminders, use the Virtual Assistant on the event page instead to get
              finer-grained controls of the audience.
            </small>
          </mdb-card-header>
          <mdb-card-body class="text-left">
            <mdb-badge v-if="workingMessage.status == 'Queued for Sending'" color="warning">Queued for Sending
            </mdb-badge>
            <mdb-badge v-if="workingMessage.status == 'Sent'" color="success">Sent
              <mdb-icon icon="check"/>
            </mdb-badge>
            <mdb-badge v-if="workingMessage.isDraft" color="warning">Draft</mdb-badge>
            <h6>Broadcast To</h6>
            <div v-if="workingMessage.isDraft">
              <select class="browser-default gp-custom-select" id="broadcast-target"
                      v-model="workingMessage.target">
                <option value="Active">Active Members of {{ currentGroup.name }}</option>
                <option value="Suspended">Suspended Members of {{ currentGroup.name }}</option>
                <option value="Pending">Pending Members of {{ currentGroup.name }}</option>
              </select>
            </div>
            <div v-if="!workingMessage.isDraft">
              <mdb-input disabled v-model="workingMessage.target" label="Broadcast To"/>
            </div>
            <mdb-row>
              <mdb-col col="5">
                <mdb-input id="direct-reply"
                           label="Allow direct reply"
                           name="direct-reply"
                           :disabled="!workingMessage.isDraft"
                           type="checkbox"
                           v-model="workingMessage.allowDirect"/>
              </mdb-col>
              <mdb-col col="7" v-if="workingMessage.allowDirect">
                <mdb-input label="From" type="text"
                           :disabled="!workingMessage.isDraft"
                           v-model="workingMessage.replyTo"/>
              </mdb-col>
            </mdb-row>
            <div>
              <mdb-input id="subject" label="Message Subject"
                         name="subject"
                         type="text"
                         v-model="workingMessage.subject"
                         required/>
            </div>

            <editor :group="currentGroup"
                    :allow-wizard="false"
                    v-if="workingMessage.isDraft"
                    :field="workingMessage.messageText" @input="workingMessage.messageText = $event"
                    label="Message Text"/>
            <div v-if="!workingMessage.isDraft" v-html="workingMessage.messageText"/>

            <div v-if="currentGroup.approved">
              <mdb-btn
                :disabled="!workingMessage.messageText || !workingMessage.subject || (!workingMessage.replyTo && workingMessage.allowDirect)"
                v-if="workingMessage.isDraft"
                @click="doSave(true)"
                color="success"
                icon="save">Save
              </mdb-btn>

              <mdb-btn v-if="workingMessage.status == 'Queued for Sending'"
                       @click="doSave(true)"
                       color="warning"
                       icon="history">Revert to Draft
              </mdb-btn>

              <mdb-btn
                :disabled="!workingMessage.isDraft || !workingMessage.messageText || (!workingMessage.replyTo && workingMessage.allowDirect)"
                @click="doSave(false)"
                color="success"
                icon="envelope">Send Now
              </mdb-btn>
              <mdb-btn @click="deleteModal=true"
                       v-if="workingMessage.isDraft || workingMessage.status == 'Queued for Sending' "
                       color="danger"
                       icon="trash">Delete
              </mdb-btn>

              <mdb-btn @click="cloneMessage"
                       v-if="!workingMessage.event"
                       color="success"
                       icon="copy">Clone
              </mdb-btn>
              <mdb-btn @click="cancelEdit"
                       color="warning"
                       icon="minus-circle">Cancel
              </mdb-btn>
              <div v-if="workingMessage.status == 'Queued for Sending'">
                <small>
                  Internal notifications are sent within 15 minutes. Emails/push notifications will be sent out based on
                  each member's
                  preferences. Some members may opt out of external notifications altogether.
                </small>
              </div>
            </div>
            <div v-if="!currentGroup.approved" class="text-info small">
              This feature is disabled until your group is approved.
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
    <yes-no-modal v-if="deleteModal" @no="deleteModal=false" @yes="doDelete"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import DataTable from "../common/DataTable";
import Editor from "../group/Editor";
import YesNoModal from "../common/YesNoModal";
import {mapState} from 'vuex'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbInputGroup,
  mdbRow
} from 'mdbvue';

export default {
  name: "group-broadcast-message",
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbInputGroup,
    mdbRow,
    mdbCol,
    mdbChipInput,
    bannerSmall,
    mdbBadge,
    Editor,
    DataTable,
    YesNoModal
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup,
                       userDetails: state => state.userDetails
                     }),
  data() {
    return {
      /*broadcast: {
       target: "active",
       allowDirect: false,
       senderEmail: null,
       text: ""
       },*/
      workingMessage: null,
      view: "list",
      currentMessage: null,
      columns: [
        {label: "Date Created", field: "createdDate"},
        {label: "Subject", field: "subject"},
        {label: "Target", field: "target"},
        {label: "Status", field: "status"},
        {label: "Date Sent", field: "processed"}
      ],
      deleteModal: false
    }
  },
  async mounted() {
    document.title = "Broadcast Message"
    if (!this.currentGroup) {
      await api.groupBasics(this.$route.params.id, "admin");
      if (this.currentGroup.role != "Admin") this.$router.push("/403")
    }
    //this.broadcast.senderEmail = this.userDetails.email
  },
  methods: {
    cancelEdit() {
      this.currentMessage = null
      this.workingMessage = null
      this.view = "list"
    },
    editMessage(msg) {
      this.currentMessage = msg
      this.workingMessage = JSON.parse(JSON.stringify(msg))
      if (!this.workingMessage.replyTo) this.workingMessage.replyTo = this.userDetails.email
      this.view = "edit"

    },
    doDelete() {
      this.deleteModal = false
      if (!this.workingMessage.id) {
        this.cancelEdit()
        return
      }
      this.$store.dispatch("setExecuting", true)
      api.delete("/group/broadcast/" + this.workingMessage.id).then(
        (results) => {
          this.$notify.success({
                                 message: "Deleted.",
                                 timeOut: 5000
                               })
          this.$store.dispatch("setDataTableReload", true)
          this.currentMessage = null
          this.workingMessage = null
          this.view = "list"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    newMessage() {
      this.workingMessage = {
        allowDirect: false,
        id: null,
        messageText: "",
        processed: null,
        replyTo: this.userDetails.email,
        subject: "",
        status: "Pending",
        target: "active",
        isDraft: true,
      }
      this.view = "edit"
    },
    cloneMessage() {
      this.workingMessage.status = "Pending"
      this.workingMessage.isDraft = true
      this.workingMessage.id = null
      this.$notify.success({
                             message: "Message cloned. You are now editing the copy.",
                             timeOut: 5000
                           })

    },
    doSave(isDraft) {
      this.workingMessage.isDraft = isDraft
      this.$store.dispatch("setExecuting", true)
      api.post("/group/broadcast/" + this.currentGroup.vanityPath, this.workingMessage).then(
        (results) => {
          if (!isDraft) {
            this.$notify.success({
                                   message: "Your message has been queued for delivery.",
                                   timeOut: 5000
                                 })
            this.currentMessage = null
            this.workingMessage = null
            this.$store.dispatch("setDataTableReload", true)
            this.view = "list"
          } else {
            if (this.workingMessage.status == 'Queued for Sending') this.workingMessage.status = "Pending"
            this.$notify.success({
                                   message: "Draft Saved.",
                                   timeOut: 5000
                                 })
            this.workingMessage.id = results.data.id
          }

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
